var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isKycUser && _vm.kycId)?_c('div',{staticClass:"kyc-id"},[_c('div',[_c('div',[_c('svg-icon',{attrs:{"icon-class":'kyc-id'}})],1),_c('div',{staticClass:"kyc-id__id-container ellipsis"},[_vm._v(" ID #"),_c('CopyText',{attrs:{"label":_vm.ellipsisCenter(_vm.kycId),"value":_vm.kycId}})],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }